import type {
  Finding,
  PolicyCategory,
  PolicyRule,
  Severity,
  Violation,
} from '@/utils/tone-policy/types';

/** Severity is policy, not a model judgment. Every MVP category is red. */
export const CATEGORY_SEVERITY: Record<PolicyCategory, Severity> = {
  piracy: 'red',
  redistribution: 'red',
  'harmful-content': 'red',
  'image-quality': 'red',
  'mixed-gear': 'red',
};

/**
 * What a rule does at high confidence. strike: private + strike. private: private, never a strike,
 * for rules a creator can break without knowing. Medium never strikes and low never acts, whatever
 * the rule (enforcement.ts).
 */
export type RuleAction = 'strike' | 'private';

export const RULE_ACTION: Record<PolicyRule, RuleAction> = {
  'current-plugin': 'strike',
  'plugin-in-chain': 'private',
  'unidentified-plugin': 'private',
  'unclear-gear': 'private',
  'current-digital-gear': 'private',
  'current-cab-sim': 'private',
  'commercial-ir': 'strike',
  'commercial-ir-in-chain': 'private',
  'all-plugin-chain': 'strike',
  'not-real-gear': 'strike',
  'stated-source': 'strike',
  'harmful-content': 'strike',
  'not-a-photo': 'private',
  'wrong-gear': 'private',
  'needs-diagram': 'private',
  'needs-no-image': 'private',
  'several-gear': 'private',
  'wrong-pack-type': 'private',
  'amp-through-cabs': 'private',
  'genre-or-artist-pack': 'private',
  other: 'private',
};

export const withSeverity = (finding: Finding): Violation => ({
  ...finding,
  severity: CATEGORY_SEVERITY[finding.category],
});
